import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDownDisabledIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.07155 7.64355C4.87428 7.44628 4.55445 7.44628 4.35718 7.64355V7.64355C4.15992 7.84082 4.15992 8.16065 4.35718 8.35791L7.29357 11.2943C7.6841 11.6848 8.31726 11.6848 8.70779 11.2943L11.6442 8.35791C11.8414 8.16065 11.8414 7.84082 11.6442 7.64355V7.64355C11.4469 7.44628 11.1271 7.44628 10.9298 7.64355L8.70779 9.86558C8.31726 10.2561 7.6841 10.2561 7.29357 9.86558L5.07155 7.64355Z",
		fill: "#D2D8DE"
	})
});
export default SvgArrowDownDisabledIcon;
